import React, { useState } from 'react';
import PrimaryButton from '../components/buttons/PrimaryButton';

const REPLY_AUTHOR_LABELS = {
  prestataire: "Prestataire",
  gestionnaire: "Gestionnaire",
  syndic: "Syndic",
};

function ReplyClaimModal({ onClose, onSubmit, initialText = "", replyAuthor = null, loading = false }) {
  const [text, setText] = useState(initialText);
  const [error, setError] = useState("");
  const replyAuthorLabel = initialText && replyAuthor ? REPLY_AUTHOR_LABELS[replyAuthor] : "";

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!text.trim()) {
      setError("La réponse est requise.");
      return;
    }
    onSubmit(text.trim());
  };

  return (
    <div className="mx-auto w-full fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-black bg-opacity-40">
      <div className="relative w-full max-w-md">
        <div className="relative bg-white rounded-lg shadow">
          <button type="button" onClick={onClose} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center">
            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span className="sr-only">Fermer</span>
          </button>
          <div className="px-6 py-6">
            <h3 className="mb-4 text-xl font-medium text-gray-900">{initialText ? "Modifier la réponse" : "Répondre"}</h3>
            {replyAuthorLabel ? (
              <p className="mb-4 text-sm text-gray-600">Réponse du {replyAuthorLabel.toLowerCase()}</p>
            ) : null}
            <form onSubmit={handleSubmit}>
              <label htmlFor="claim-reply" className="block mb-2 text-sm font-medium text-gray-900">Réponse</label>
              <textarea
                id="claim-reply"
                value={text}
                onChange={(event) => setText(event.target.value)}
                rows={5}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
              />
              {error !== "" ? <p className="mt-2 text-sm text-red-500">{error}</p> : null}
              <div className="mt-4 text-center">
                <PrimaryButton type="submit" value={initialText ? "Modifier" : "Enregistrer"} loading={loading} />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReplyClaimModal;
